import { sharedTheme } from './shared';

// Utility functions for working with the shared theme

/**
 * Get a color value from the shared theme
 * @param color - Color name (e.g., 'customBlue')
 * @param shade - Shade index (0-9)
 * @returns CSS color value
 */
export const getColor = (color: keyof typeof sharedTheme.colors, shade: number = 5): string => {
  const colorArray = sharedTheme.colors[color];
  if (Array.isArray(colorArray)) {
    return colorArray[shade] || colorArray[5]; // Default to shade 5
  }
  return colorArray as string;
};

/**
 * Get a spacing value from the shared theme
 * @param size - Spacing size key
 * @returns CSS spacing value
 */
export const getSpacing = (size: keyof typeof sharedTheme.spacing): string =>
  sharedTheme.spacing[size];

/**
 * Get a font size value from the shared theme
 * @param size - Font size key
 * @returns CSS font size value
 */
export const getFontSize = (size: keyof typeof sharedTheme.fontSizes): string =>
  sharedTheme.fontSizes[size];

/**
 * Get a border radius value from the shared theme
 * @param size - Border radius key
 * @returns CSS border radius value
 */
export const getBorderRadius = (size: keyof typeof sharedTheme.borderRadius): string =>
  sharedTheme.borderRadius[size];

/**
 * Get a breakpoint value from the shared theme
 * @param size - Breakpoint key
 * @returns CSS breakpoint value
 */
export const getBreakpoint = (size: keyof typeof sharedTheme.breakpoints): string =>
  sharedTheme.breakpoints[size];

// CSS custom properties for use in styles
export const cssVariables = {
  '--color-custom-blue-5': getColor('customBlue', 5),
  '--color-custom-blue-6': getColor('customBlue', 6),
  '--spacing-md': getSpacing(4),
  '--spacing-lg': getSpacing(5),
  '--font-size-sm': getFontSize('sm'),
  '--font-size-base': getFontSize('base'),
  '--border-radius-md': getBorderRadius('md'),
} as const;
